import { render, staticRenderFns } from "./RegistrationFormSmsCheckbox.vue?vue&type=template&id=064ccddf&scoped=true"
import script from "./RegistrationFormSmsCheckbox.vue?vue&type=script&lang=js"
export * from "./RegistrationFormSmsCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ccddf",
  null
  
)

export default component.exports